<template>
  <b-card-code
      title="Új hozzáadása"
  >
    <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        rounded="sm"
    >
      <!-- form -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group
                  label="Név"
              >
                <validation-provider
                    #default="{ errors }"
                    name="név"
                    rules="required"
                    vid="name"
                >
                  <b-form-input
                      v-model="formData.name"
                      :state="errors.length > 0 ? false:null"
                      placeholder="név"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                  label="E-mail cím"
              >
                <validation-provider
                    #default="{ errors }"
                    name="e-mail cím"
                    rules="required|email"
                    vid="email"
                >
                  <b-form-input
                      v-model="formData.email"
                      :state="errors.length > 0 ? false:null"
                      placeholder="teszt@rekordlista.mohosz.hu"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                  label="Jelszó"
              >
                <validation-provider
                    #default="{ errors }"
                    name="jelszó"
                    rules="required"
                    vid="password"
                >
                  <b-form-input
                      v-model="formData.password"
                      :state="errors.length > 0 ? false:null"
                      placeholder="***********"
                  />
                  <password
                      v-model="formData.password"
                      :secure-length="8"
                      :strength-meter-only="true"
                      @score="score => updateScore('password', score)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <div class="password-strength mt-1" v-show="formData.password.length > 0">
                    <strong>Jelszó erősség:</strong> {{ passwordStrengthText(passwordScore) }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                  label="Jelszó ismét"
              >
                <validation-provider
                    #default="{ errors }"
                    name="jelszó ismét"
                    rules="required"
                    vid="confirm_password"
                >
                  <b-form-input
                      v-model="formData.confirm_password"
                      :state="errors.length > 0 ? false:null"
                      placeholder="***********"
                  />
                  <password
                      v-model="formData.confirm_password"
                      :secure-length="8"
                      :strength-meter-only="true"
                      @score="score => updateScore('confirm_password', score)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <div class="password-strength mt-1" v-show="formData.confirm_password.length > 0">
                    <strong>Jelszó erősség:</strong> {{ passwordStrengthText(confirmPasswordScore) }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                  label="Szerepkör"
              >
                <validation-provider
                    #default="{ errors }"
                    name="szerepkör"
                    rules=""
                    vid="role"
                >
                  <v-select
                      v-model="formData.role"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="roleOptions"
                  >
                      <template #no-options>
                          <span style="">Sajnáljuk, nincs egyező találat.</span>
                      </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                  label="Megjegyzés"
              >
                <validation-provider
                    #default="{ errors }"
                    name="megjegyzés"
                    vid="comment"
                >
                  <editor
                      v-model="formData.comment"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- submit button -->
            <b-col class="mt-1">
              <b-button
                  variant="primary"
                  type="submit"
                  class="float-right"
                  @click.prevent="submitForm"
              >
                Mentés
              </b-button>
              <cancel-and-g-o-t-o-previous-page class="mr-2"/>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BOverlay,
} from 'bootstrap-vue'
import {
  required, email,
} from '@validations'
import vSelect from 'vue-select'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import editor from "@/views/pages/_components/editor.vue";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Password from 'vue-password-strength-meter'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BOverlay,
    vSelect,
    cancelAndGOTOPreviousPage,
    editor,
    VuePhoneNumberInput,
    Password,
  },
  data() {
    return {
      role: 'user',
      loading: false,
      formData: {
        name: '',
        email: '',
        password: '',
        confirm_password: '',
        role: '',
        comment: '',
      },
      roleOptions: [],
      passwordScore: 0,
      confirmPasswordScore: 0,
      required,
      email,
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch('fetchRolesForSelect').then(response => {
      this.roleOptions = response
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    updateScore(field, score) {
      this.$nextTick(() => {
        if (field === 'password') {
          this.passwordScore = score;
        } else if (field === 'confirm_password') {
          this.confirmPasswordScore = score;
        }
      });
    },
    passwordStrengthText(score) {
      if (score < 3) return 'Nem megfelelő'
      return 'Megfelelő'
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loading = true

          // clone formData
          let fd = JSON.parse(JSON.stringify(this.formData))

          if (this.formData.role) {
            fd.role = this.formData.role.value
          }

          this.$store.dispatch('storeUser', fd).then(() => {
            this.$helpers.showSuccessToast('Új felhasználó létrehozva.')

            this.$acl.canListPermission(this.role)
                ? this.$router.push({name: 'users'})
                : this.$router.go(-1)
          }).catch(error => {
            if (error.response.status === 422) {
              this.$refs.simpleRules.setErrors(error.response.data.errors)
            } else {
              this.$helpers.showErrorToast(error.toString())
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
